import Head from 'next/head';

function generateSmartlookScript(
  smartlookKey: string,
  smartlookRegion: string,
) {
  return `
  window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '${smartlookKey}', { region: '${smartlookRegion}' });
  `;
}

const Smartlook: React.FC<{
  readonly smartlookKey: string;
  readonly smartlookRegion: string;
}> = ({ smartlookKey, smartlookRegion }) => {
  return (
    <Head>
      <script
        type="text/javascript"
        key="smartlook"
        dangerouslySetInnerHTML={{
          __html: generateSmartlookScript(smartlookKey, smartlookRegion),
        }}
      ></script>
    </Head>
  );
};

export default Smartlook;
